import find from 'lodash/find'
import forEach from 'lodash/forEach'

declare global {
  interface GlobalEventHandlersEventMap {
    ucEvent: CustomEvent<{
      event: string
    } & Record<string, boolean>>
  }

  interface Window {
    UC_UI?: {
      getServicesBaseInfo: () => {
        consent: {
          status: boolean
        }
        name: string
      }[]
    }
  }
}

type ConsentListener = (hasConsent: boolean) => void

const consent = {
  value: false,

  get hasConsent() {
    return this.value
  },
  set hasConsent(value: boolean) {
    if (this.value === value) {
      return
    }

    this.value = value
    forEach(Array.from<ConsentListener>(this.listeners), listener => listener(value))
  },

  check() {
    if (typeof window === 'undefined') {
      this.hasConsent = false
      return
    }

    if (!window.UC_UI?.getServicesBaseInfo) {
      return
    }

    const services = window.UC_UI.getServicesBaseInfo()
    const serviceAmplitude = find(services, ['name', 'Amplitude'])
    const serviceMParticle = find(services, ['name', 'mParticle'])

    if (!serviceAmplitude || !serviceMParticle) {
      return
    }

    this.hasConsent = serviceAmplitude?.consent?.status === true || serviceMParticle?.consent?.status === true
  },

  listeners: new Set<ConsentListener>(),
  addEventListener(listener: ConsentListener) {
    this.listeners.add(listener)
  },
  removeEventListener(listener: ConsentListener) {
    this.listeners.delete(listener)
  },
}

if (typeof window !== 'undefined') {
  window.addEventListener('ucEvent', (e) => {
    if (!e.detail || e.detail.event !== 'consent_status') {
      return
    }

    let change: boolean | null = null
    if (e.detail.Amplitude === true || e.detail.Amplitude === false) {
      change = e.detail.Amplitude
    }
    if ((e.detail.mParticle === true || e.detail.mParticle === false) && change !== true) {
      change = e.detail.mParticle
    }

    if (change !== null) {
      consent.hasConsent = change
    }

    consent.check()
  })

  consent.check()
}

export default consent
